<template>
  <div>
    <div v-show="false">
        <img id="starImg" style="height:100%; width:100%;" :src="img" />
    </div>
    <!--画布-->
    <canvas v-show="false" id="main" ref="main" height="1260" width="1830" style="border:1px solid #d3d3d3;"></canvas>
    <!-- <img v-show="imgurl!=''" id="canvasImg" class="imgcer" :src="imgurl" @click="imgShow=true;"/> -->
    <div v-if="imgShow" style="width:100%;height:100%;position: fixed;top:0;left:0;z-index:3000;background:#808080;">
      <img v-show="imgurl!=''" id="canvasImg" style="width:100%;height:100%;" :src="imgurl" @click="imgShow=false;"/>
    </div>
    <el-button type="primary" style="position: absolute;right: 16px;top: 113px;" @click="shenhe">确 定</el-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imgurl:"",
      Year:"",
      Month:"",
      Day:"",
      canvas: null,
      imgShow:false,
      coverInfo:null,
      imgurlInfo:null,
      count: 2,
      dialogVisible:false
    };
  },
  props: {
    DateCreated:{
      type: String,
      default: "2019/4/10 10:37:43"
    },
    userIdentifier:{
      type: String,
      default: "349842199719716816"
    },
    identifier:{
      type: String,
      default: "176485239475124"
    },
    cover:{
      type: String,
      default: ""
    },
    img: {
      type: String,
      default: "https://file.clpp.org.cn/66ykt/ori/qagzal6ooltkgnilzlcx4q/MhJhQsteJkZPEeiE.png"
    },
    desc: {
      type: String,
      default: "王涛"
    },
    name: {
      type: String,
      default: "初级物流师"
    },
    AttestationId:{
      type: String,
      default: ""
    },
    stuId:{
      type: String,
      default: ""
    },
    IsAdopt:{
      type: Number,
      default: 0
    },
    joinAttestationId:{
      type: String,
      default: ""
    }
  },
  components: {
  },
  mounted() {

    this.canvas = this.$refs.main;
    this.coverInfo = new Image();
    this.imgurlInfo = new Image();


    this.coverInfo.crossOrigin = "anonymous";
    this.imgurlInfo.crossOrigin = "anonymous";

    this.coverInfo.src= this.cover + "?t=" +　(new Date().getTime());
    this.imgurlInfo.src= this.img + "?t=" +　(new Date().getTime());
    if(this.cover=="" || this.cover==null){
      this.count=1;
      this.imgurlInfo.onload = this.onImageLoaded;
    }else{
      this.coverInfo.onload =  this.onImageLoaded;
      this.imgurlInfo.onload = this.onImageLoaded;
    }
    
    // this.hechen();
  },
  methods: {
    submit(){
      if(this.IsAdopt==1){

      }else{

      }
    },
    onImageLoaded() {
      if(--this.count === 0) {
        this.hechen();         
      }
    },
    hechen(){
      var that=this;
      if(this.DateCreated!=""){
        var time = new Date(this.DateCreated);
        this.Year=time.getFullYear();
        this.Month=time.getMonth();
        this.Day=time.getDate();
      }
		  //获取时间2012-12-12
      var mydate = new Date();
      var date = mydate.getFullYear()+'-'+(mydate.getMonth()+1)+'-'+mydate.getDate();
      var year=mydate.getFullYear();
      var month=mydate.getMonth()+1;
      var day=mydate.getDate();
      //获取画布对象
      var mainCtx = this.canvas.getContext('2d');
      var maxWidth = mainCtx.width;
      var maxHeight = mainCtx.height;
      
      mainCtx.clearRect(0,0,1000,1000);
      //先把图片绘制在这里
　　  mainCtx.drawImage(that.imgurlInfo,0,0,1830,1260);
      if(that.cover!=""){
        //先把头像绘制在这里
        mainCtx.drawImage(that.coverInfo,374,384,230,300);
      }
      //设置用户文本的大小字体等属性
      mainCtx.font = "small-caps bold 29px STXinwei";
      //设置用户文本填充颜色
      mainCtx.fillStyle = "black";
      //绘制姓名
      mainCtx.fillText(that.desc,1030,407);
      //绘制加入时间
      mainCtx.fillText(that.Year,1260,410);
      mainCtx.fillText(that.Month,1435,410);
      mainCtx.fillText(that.Day,1580,410);
      //绘制考试结束时间
      mainCtx.fillText(year,1030,482);
      mainCtx.fillText(month,1170,482);
      mainCtx.fillText(day,1250,482);
      //绘制发证时间
      mainCtx.fillText(year,1260,1055);
      mainCtx.fillText(month,1375,1055);
      mainCtx.fillText(day,1445,1055);  
      //设置活动名称
      mainCtx.fillText(that.name,1030,545);
      //设置身份证
      mainCtx.fillText(that.userIdentifier,408,844);
      //设置证书编号
      mainCtx.fillText(that.identifier,408,940);
      
      
    },
    //通过id获取canvas对象
    getCanvasContext(id){
      var canvas = document.getElementById(id);
      //检测浏览器是否支持canvas 该方法是否存在 取得上下文对象
      if (canvas.getContext) {
          return canvas.getContext('2d'); //2d用单引用括起来
      }
      return null;
    },
    createImage(file) {
      var BASE64_MARKER = ';base64,';
      if (file.indexOf(BASE64_MARKER) == -1) {
        var parts = file.split(',');
        var contentType = parts[0].split(':')[1];
        var raw = decodeURIComponent(parts[1]);
        return new Blob([raw], { type: contentType });
      }
      var parts = file.split(BASE64_MARKER);
      var contentType = parts[0].split(':')[1];
      var raw = window.atob(parts[1]);
      var rawLength = raw.length;

      var uInt8Array = new Uint8Array(rawLength);

      for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], { type: contentType });
    },
    submitStaff(file) {
      var that=this;
      aliossAccess().then(oss => {
        console.log(oss);
        const formData = new FormData();
        let filename = Date.now().toString(36)+'.jpg';
        oss.host = oss.host.replace(/^http:/, location.protocol);
        formData.append('key', keygen(filename, 16));
        formData.append('callback', oss.callback);
        formData.append('policy', oss.policy);
        formData.append('signature', oss.signature);
        formData.append('OSSAccessKeyId', oss.accessid);
        formData.append('success_action_status', 200);
        formData.append('x:isneedsave', 1);
        formData.append('x:userid', oss.userid);
        formData.append('x:name', (filename || 'untitled'));
        formData.append('file', file);
        that.$http.post(oss.host, formData).then(function(response) {
            that.$http.post("/api/XOrg/StudentManager/addCertificate", {
              userId: that.stuId,
              url: response.docPath,
              AttestationId: that.AttestationId
            }).then(function(rst) {
            });
            that.$http.post("/api/XOrg/StudentManager/updateIsAdopt", {
              Id: that.joinAttestationId,
              IsAdopt: 1
            }).then(function(res) {
              if (res.code > 0) {
                that.$message.success(res.msg);
              } else {
                that.$message.warning(res.msg);
              }
            });
          }).catch(function(error) {
            console.log(error);
          });
      });
    },
    shenhe() {
      if (this.IsAdopt == 2) {
        var that = this;
        this.$http.post("/api/XOrg/StudentManager/updateIsAdopt", {
            Id: this.joinAttestationId,
            IsAdopt: 2
          }).then(function(rst) {
            if (rst.code > 0) {
              that.$message.success(rst.msg);
              that.$emit('onClick',that.dialogVisible)
            } else {
              that.$message.warning(rst.msg);
            }
          });
      }else if (this.IsAdopt == 1) {
        this.$emit('onClick',this.dialogVisible)
        var image = this.canvas.toDataURL("image/jpg");
        this.submitStaff(this.createImage(image));
      }
    },
  }
};
</script>

<style lang="scss">
.admin-exit {
  width: 50px;
  height: 50px;
  border: 1px solid #ccc;
  background-color: #ccc;
  position: absolute;
  left: 10px;
  bottom: 50px;
  cursor: pointer;
}
.imgcer{
  height:345px; 
  width:500px;
}
</style>